import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "partner-menu-items";
function mergeDuplicates(axios, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["merge-duplicates"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function getAll(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function get(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function post(axios, body) {
	const config = {
		entityPathSegment
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function put(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function sort(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "sort"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function createParentPartnerMenuItem(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "parent-partner-menu-items"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function reassignParentPartnerMenuItem(axios, id, ParentPartnerMenuItemId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "parent-partner-menu-items", ParentPartnerMenuItemId]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
export {
	createParentPartnerMenuItem,
	get,
	getAll,
	mergeDuplicates,
	post,
	put,
	reassignParentPartnerMenuItem,
	sort
};
